import React from 'react'
import cx from 'classnames'
import './style.css'

const BuildItem = ({ name, type, selectedIconSrc, defaultIconSrc, selectedType, onClick }) => {
  const isSelected = type === selectedType
  const iconSrc = isSelected ? selectedIconSrc : defaultIconSrc

  const classNames = cx('build-item', {
    'build-item-selected': isSelected
  })

  return (
    <div className={classNames} onClick={() => onClick(type)}>
      <div className="build-item-logo-wrapper">
        <img src={iconSrc} alt="build item logo" />
      </div>
      <span className="build-item-name">
        {name}
      </span>
    </div>
  )
}

export default BuildItem
